const data = {
  id: "money",
  title: "Follow the Money",
  intro: "You scratch my back, I'll scratch yours — and the rest of you lose. Campaign donors become contractors. Developers get Tax Increment Financing (TIF) districts. Public tax revenue gets redirected to private projects. The pay-to-play relationships shaping Huntsville — documented.",
  tabs: [
    {
      id: "connections_map",
      label: "Connections Map",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "donor_profiles",
      label: "Donor Profiles",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "exec_vs_worker",
      label: "Exec Pay vs. Worker Pay",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "contracts_vendors",
      label: "Contracts & Vendors",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
